export default {
  "b2b.doplnkova-sluzba-editace-form.field.nazevCs.label": "Název CS",
  "b2b.doplnkova-sluzba-editace-form.field.nazevEn.label": "Název EN",
  "b2b.doplnkova-sluzba-editace-form.field.popisCs.label": "Popis CS",
  "b2b.doplnkova-sluzba-editace-form.field.popisEn.label": "Popis EN",
  "b2b.doplnkova-sluzba-editace-form.field.zkratka.label": "Zkratka",
  "b2b.doplnkova-sluzba-editace-form.field.uzivaNapajeni.label":
    "Užívá napájení",
  "b2b.doplnkova-sluzba-editace-form.field.vylucny.label": "Výlučný",
  "b2b.doplnkova-sluzba-editace-form.field.parkovani.label": "Parkování",
  "b2b.doplnkova-sluzba-editace-form.field.bezCasu.label": "Bez času",
  "b2b.doplnkova-sluzba-editace-form.field.platnostOd.label": "Platnost od",
  "b2b.doplnkova-sluzba-editace-form.button.delete": "Smazat",
  "b2b.doplnkova-sluzba-editace-form.button.submit": "Uložit",
  "b2b.doplnkova-sluzba-editace-form.button.cancel": "Zrušit",
  "b2b.doplnkova-sluzba-editace-widget.titleNew": "Nová dopňková služba",
  "b2b.doplnkova-sluzba-editace-form.save-dialog.title":
    "Uložení doplňkové služby",
  "b2b.doplnkova-sluzba-editace-form.delete-dialog.title":
    "Odstranění doplňkové služby"
};
